// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let Scalars = require("../scalars/Scalars.bs.js");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_property_agentV2(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["VisibleForSalePropertyAgent"]);
}

function unwrap_fragment_property_propertyLocation(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "PropertyLocationWithHiddenAddress",
    "PropertyLocationWithVisibleAddress"
  ]);
}

let fragmentConverter = {"__root":{"startDateV2":{"c":"Scalars.PlainDateTime"},"property_showings_edges_node_startDate":{"b":""},"property_propertyLocation":{"u":"fragment_property_propertyLocation"},"property_agentV2_VisibleForSalePropertyAgent_agent":{"f":""},"property_agentV2":{"u":"fragment_property_agentV2"},"property":{"f":""},"endDateV2":{"c":"Scalars.PlainDateTime"}}};

let fragmentConverterMap = {
  "Scalars.PlainDateTime": Scalars.PlainDateTime.parse,
  fragment_property_agentV2: unwrap_fragment_property_agentV2,
  fragment_property_propertyLocation: unwrap_fragment_property_propertyLocation
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function showingTypeV5_decode($$enum) {
  if ($$enum === "AGENTS_ONLY" || $$enum === "TAN_ONLY" || $$enum === "BUYERS_WELCOME") {
    return $$enum;
  }
}

let showingTypeV5_fromString = showingTypeV5_decode;

function visibilityReason_decode($$enum) {
  if ($$enum === "VISIBLE_TO_ACCOUNT_MEMBER" || $$enum === "VISIBLE_TO_TAN_STAFF" || $$enum === "VISIBLE_TO_ALL") {
    return $$enum;
  }
}

let visibilityReason_fromString = visibilityReason_decode;

let Utils = {
  showingTypeV5_decode: showingTypeV5_decode,
  showingTypeV5_fromString: showingTypeV5_fromString,
  visibilityReason_decode: visibilityReason_decode,
  visibilityReason_fromString: visibilityReason_fromString
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationDisplay",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShowingsPageRelayShowingsByDay_showing",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startDateV2",
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endDateV2",
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "type_",
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notes",
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "ForSalePropertyV5",
        "kind": "LinkedField",
        "name": "property",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PropertyMlsLabel_propertyV5"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "agentV2",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "alias": null,
                      "args": null,
                      "concreteType": "Agent",
                      "kind": "LinkedField",
                      "name": "agent",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "AgentInfo_agent"
                        }
                      ],
                      "storageKey": null
                    },
                    "action": "NONE"
                  }
                ],
                "type": "VisibleForSalePropertyAgent",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "propertyLocation",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "address",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "visibilityRule",
                    "storageKey": null
                  }
                ],
                "type": "PropertyLocationWithVisibleAddress",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/)
                ],
                "type": "PropertyLocationWithHiddenAddress",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PropertyShowingConnection",
            "kind": "LinkedField",
            "name": "showings",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "concreteType": "PropertyShowingEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "alias": null,
                        "args": null,
                        "concreteType": "ShowingV5",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "kind": "RequiredField",
                            "field": {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "startDate",
                              "storageKey": null
                            },
                            "action": "NONE"
                          },
                          {
                            "kind": "RequiredField",
                            "field": {
                              "alias": null,
                              "args": null,
                              "concreteType": "ForSalePropertyV5",
                              "kind": "LinkedField",
                              "name": "property",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/)
                              ],
                              "storageKey": null
                            },
                            "action": "NONE"
                          }
                        ],
                        "storageKey": null
                      },
                      "action": "NONE"
                    }
                  ],
                  "storageKey": null
                },
                "action": "NONE"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "ShowingV5",
  "abstractKey": null
};
})());

let wrap_fragment_property_agentV2 = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_property_propertyLocation = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_property_agentV2 = unwrap_fragment_property_agentV2;
exports.wrap_fragment_property_agentV2 = wrap_fragment_property_agentV2;
exports.unwrap_fragment_property_propertyLocation = unwrap_fragment_property_propertyLocation;
exports.wrap_fragment_property_propertyLocation = wrap_fragment_property_propertyLocation;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
